// @flow

import type { Action, State } from './types';

const initialState: State = {
  fetching: false,
  error: false,
  content: [],
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'REQUEST_NETWORKS':
      return {
        ...state,
        fetching: true,
        error: false,
        content: [],
      };
    case 'RECEIVE_NETWORKS': {
      const { payload } = action;
      return {
        ...state,
        fetching: false,
        error: false,
        content: payload.filter(item => item.network_id && item.name),
      };
    }
    case 'REQUEST_NETWORKS_ERROR': {
      const { payload: error } = action;
      return {
        ...state,
        fetching: false,
        error: error.error,
        content: [],
      };
    }
    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
